export const FALLBACK_SEARCH_CARD_IMAGE: string = '/assets/img/fallback-search-card-image.svg';
export const FALLBACK_ARTICLE_CARD_IMAGE: string = '/assets/img/fallback-search-card-image.svg';
export const FALLBACK_PRODUCT_CARD_IMAGE: string = '/assets/img/fallback-unavailable.svg';

export const FALLBACK_LOGO_SRC: string = '/assets/img/ppg-logo.svg';
export const FALLBACK_FOOTER_LOGO_SRC: string = '/assets/img/ppg-footer-logo.png';
export const FALLBACK_FAVICON_SRC: string = '/assets/img/favicon-ppg.svg';
